export { Asteroid, addAsteroidToScene, breakAsteroid } from "./Asteroid";